
<template>
    <Modal v-model="modal"
           :title="$t('确认')"
           width="500"
           :mask-closable="false"
           :closable='false'
           class="discountmodal">
        <p slot="header"
           style="display: none;"></p>
        <div class="delete-container"
             style="padding-bottom: 0;">
            <i class="ivu-icon ivu-icon-ios-help-circle"></i>
            <div class="content">
                <h4> {{titleTxt}}</h4>
                <p class="desc">{{ contentTxt}}</p>
            </div>
        </div>
        <div slot="footer">
            <Button type="primary"
                    @click="submit">
                <span>{{$t('确定')}}</span>
            </Button>
        </div>
    </Modal>
</template>

<script>
export default {
    name: 'discountmodal',
    props: ['titleTxt', 'contentTxt'],
    data () {
        return {
            modal: false
        }
    },
    created () { },
    methods: {
        openModal () {
            this.modal = true
        },
        submit () {
            this.$emit('modalFun')
            this.modal = false
        }
    }
}
</script>

<style lang="less" scoped>
.delete-container {
    // text-align: center;
    padding: 0 0 20px 5px;
    i {
        color: #ff9900;
        font-size: 28px;
        float: left;
    }
    h4 {
        font-size: 14px;
        padding: 3px 0 10px 0;
        font-weight: 500;
        color: #17233d;
    }
    .content {
        padding-left: 38px;
    }
    .desc {
        color: #515a6e;
        font-size: 12px;
    }
}
</style>
<style lang="less">
.discountmodal {
    .ivu-modal-header {
        padding-top: 0px;
        padding-bottom: 10px;
        border: none;
    }
    .ivu-modal-footer {
        padding-top: 0px;
        border: none;
    }
}
</style>
